import { render } from "./SectionIntro.vue?vue&type=template&id=a5971be6"
import script from "./SectionIntro.vue?vue&type=script&lang=js"
export * from "./SectionIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__